import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export type VariantBadge =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "pending"
  | "approved"
  | "rejected"
  | "completed";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        pending:
          "border-transparent bg-yellow-500 text-yellow-900 hover:bg-yellow-600",
        approved:
          "border-transparent bg-green-500 text-white hover:bg-green-600",
        rejected: "border-transparent bg-red-500 text-white hover:bg-red-600",
        completed:
          "border-transparent bg-blue-500 text-white hover:bg-blue-600",
        reproved: "border-transparent bg-red-500 text-white hover:bg-red-400",
        autoApproved:
          "border-transparent bg-blue-500 text-white hover:bg-blue-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: any) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
